module.exports = __webpack_public_path__ + "ea9a8d72f5a5104089aa4ea7ca59b4ea.MP3";